/**
 * A project's icon (T-25): one of these Lucide icons, shown in the project's colour in the sidebar
 * and on the Projects list. Null (never picked) shows the default, folder-git-2. The frontend maps
 * each name to its component (components/factory/project-icons.ts), so a name added here needs one there.
 */
export const PROJECT_ICONS = [
  'folder-git-2',
  'factory',
  'rocket',
  'code',
  'terminal',
  'globe',
  'store',
  'shopping-cart',
  'package',
  'boxes',
  'database',
  'server',
  'cloud',
  'cpu',
  'smartphone',
  'monitor',
  'layout-dashboard',
  'chart-line',
  'calculator',
  'wallet',
  'receipt',
  'book-open',
  'file-text',
  'mail',
  'message-square',
  'calendar',
  'users',
  'briefcase',
  'building-2',
  'house',
  'wrench',
  'hammer',
  'bot',
  'brain',
  'sparkles',
  'zap',
  'flame',
  'leaf',
  'heart',
  'star',
  'shield',
  'lock',
  'key',
  'camera',
  'music',
  'gamepad-2',
  'truck',
  'plane',
] as const;

export type ProjectIconName = (typeof PROJECT_ICONS)[number];

export const DEFAULT_PROJECT_ICON: ProjectIconName = 'folder-git-2';

const KNOWN = new Set<string>(PROJECT_ICONS);

/** A name from PROJECT_ICONS, else null. */
export function normaliseProjectIcon(raw: unknown): ProjectIconName | null {
  if (typeof raw !== 'string') return null;
  const name = raw.trim().toLowerCase();
  return KNOWN.has(name) ? (name as ProjectIconName) : null;
}
